import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Button, Card, Container, Form, Pagination, Table } from "react-bootstrap";

const TampilDaftarEntryRacikan = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const limit = 10;

  useEffect(() => {
    loadRows();
  }, [page, search]);

  const loadRows = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        tempUrl + "/entryRacikansPagination?search_query=" + encodeURIComponent(search) + "&page=" + page + "&limit=" + limit,
        {
          dariTanggal: user.tutupperiode?.dariTanggal,
          sampaiTanggal: user.tutupperiode?.sampaiTanggal,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        },
      );
      setRows(response.data.entryRacikans || []);
      setPages(response.data.totalPage || 0);
    } catch (error) {
      alert(error.response?.data?.message || error.message);
    }
    setLoading(false);
  };

  if (loading) return <Loader />;

  const searchData = (event) => {
    event.preventDefault();
    setPage(0);
    setSearch(query.toUpperCase());
  };

  return (
    <Container fluid className="py-3 px-2 px-md-4">
      <div className="text-secondary small">Transaksi</div>
      <h3 className="fw-bold mb-1">Daftar Entry Racikan</h3>
      <p className="text-muted mb-3">Periode: {user.tutupperiode?.namaPeriode || "-"}</p>
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-2">
          <span className="fw-semibold">Entry Racikan</span>
          <Button size="sm" variant="light" onClick={() => navigate("/daftarEntryRacikan/entryRacikan/tambah")}>+ Tambah</Button>
        </Card.Header>
        <Card.Body className="p-2 p-md-3">
          <Form onSubmit={searchData}>
            <Form.Control size="sm" className="mb-3" placeholder="Cari no. bukti atau tanggal..." value={query} onChange={(event) => setQuery(event.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} />
          </Form>
          <Table responsive bordered hover size="sm" className="align-middle mb-0">
            <thead className="table-primary">
              <tr><th>No. Bukti</th><th>Tanggal</th><th>COA</th><th className="text-center">Jumlah Racikan</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={4} className="text-center text-muted py-3">Belum ada data</td></tr>}
              {rows.map((row) => (
                <tr key={row.id} onClick={() => navigate("/daftarEntryRacikan/entryRacikan/" + row.id)} style={{ cursor: "pointer" }}>
                  <td className="fw-semibold">{row.noBukti}</td>
                  <td>{row.tanggal}</td>
                  <td>{row.coa ? row.coa.kodeCOA + " - " + row.coa.namaCOA : "-"}</td>
                  <td className="text-center">{row.children?.length || 0}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination size="sm" className="mt-3 mb-0">
            <Pagination.First disabled={page === 0} onClick={() => setPage(0)} />
            <Pagination.Prev disabled={page === 0} onClick={() => setPage((value) => Math.max(0, value - 1))} />
            <Pagination.Item active>{page + 1}</Pagination.Item>
            <Pagination.Next disabled={pages === 0 || page >= pages - 1} onClick={() => setPage((value) => Math.min(pages - 1, value + 1))} />
            <Pagination.Last disabled={pages === 0 || page >= pages - 1} onClick={() => setPage(Math.max(0, pages - 1))} />
          </Pagination>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilDaftarEntryRacikan;
